var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var template = "\n  <div class=\"adap-swiper\">\n    <transition-expand>\n      <div v-if=\"slides.length\" :key=\"1\">\n        <slot name=\"header\" />\n\n        <div class=\"adap-swiper__content\">\n          <swiper\n            ref=\"swiperComponent\"\n            v-bind=\"vBind\"\n            v-on=\"vOn\"\n            :options=\"options\"\n            :cleanupStylesOnDestroy=\"cleanupStylesOnDestroy\"\n            @slideChange=\"pageChangeEvent\"\n            class=\"swiper-container--sm-edge-preview\"\n          >\n            <swiper-slide\n              v-for=\"(item, i) in slides\"\n              :key=\"item.$id\"\n              :class=\"slideClass\"\n            >\n              <slot name=\"slide\" :item=\"item\" :i=\"i\" />\n            </swiper-slide>\n          </swiper>\n\n          <await :name=\"spinner\" class=\"await__spinner--screen-light\" v-bind:class=\"{hidden: awaitIsHidden}\" style=\"z-index: 10\" />\n        </div>\n      </div>\n\n      <div v-else :key=\"2\">\n        <await :name=\"spinner\">\n          <slot name=\"empty\" />\n        </await>\n      </div>\n    </transition-expand>\n  </div>\n";
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { ExpansibleCollection } from '@simpli/resource-collection';
import { MixinAdapScreenSize } from './MixinAdapScreenSize';
import AdapTableWrapper from './index';
var AdapSwiper = /** @class */ (function (_super) {
    __extends(AdapSwiper, _super);
    function AdapSwiper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.locked = false;
        _this.slides = [];
        _this.isBeginning = true;
        _this.isEnd = false;
        _this.SMALL_SCREEN = AdapTableWrapper.screenSmall;
        _this.MEDIUM_SCREEN = AdapTableWrapper.screenMedium;
        _this.LARGE_SCREEN = AdapTableWrapper.screenLarge;
        return _this;
    }
    Object.defineProperty(AdapSwiper.prototype, "vBind", {
        get: function () {
            return __assign({}, this.$attrs);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdapSwiper.prototype, "vOn", {
        get: function () {
            var listeners = __assign({}, this.$listeners);
            delete listeners.input;
            delete listeners.slideChange;
            return listeners;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * In order to clean the cache, the collection empty its content and then repopulate it.
     * To prevent malfunction of swiper, this watch does not accept empty list
     * @param items
     */
    AdapSwiper.prototype.itemsEvent = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (items && items.length) {
                    this.slides = items;
                }
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(AdapSwiper.prototype, "swiperComponent", {
        get: function () {
            return this.$refs.swiperComponent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdapSwiper.prototype, "breakpoints", {
        get: function () {
            var swiperOptions = AdapTableWrapper.options.swiperOptions;
            var breakpoints = (swiperOptions && swiperOptions.breakpoints) || {};
            return (this.options && this.options.breakpoints) || breakpoints;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdapSwiper.prototype, "mobilePerPage", {
        get: function () {
            var breakpoints = this.breakpoints[this.SMALL_SCREEN];
            return Number(breakpoints && breakpoints.slidesPerView);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdapSwiper.prototype, "tabletPerPage", {
        get: function () {
            var breakpoints = this.breakpoints[this.MEDIUM_SCREEN];
            return Number(breakpoints && breakpoints.slidesPerView);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdapSwiper.prototype, "desktopPerPage", {
        get: function () {
            var breakpoints = this.breakpoints[this.LARGE_SCREEN];
            return Number(breakpoints && breakpoints.slidesPerView);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdapSwiper.prototype, "perPage", {
        get: function () {
            if (this.isMobile)
                return this.mobilePerPage;
            if (this.isTablet)
                return this.tabletPerPage;
            return this.desktopPerPage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdapSwiper.prototype, "hasReachedTheLimit", {
        get: function () {
            return this.collection.size() >= (this.collection.total || 0);
        },
        enumerable: true,
        configurable: true
    });
    AdapSwiper.prototype.created = function () {
        this.collection.perPage = 4 * this.perPage;
    };
    AdapSwiper.prototype.mounted = function () {
        var component = this.$refs.swiperComponent;
        if (component) {
            this.$emit('init', component.$swiper);
        }
    };
    AdapSwiper.prototype.nextSlide = function () {
        var component = this.$refs.swiperComponent;
        if (component) {
            component.$swiper.slideNext();
        }
    };
    AdapSwiper.prototype.prevSlide = function () {
        var component = this.$refs.swiperComponent;
        if (component) {
            component.$swiper.slidePrev();
        }
    };
    AdapSwiper.prototype.pageChangeEvent = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.$emit('slideChange', args);
                        this.isBeginning = Boolean(this.swiperComponent && this.swiperComponent.$swiper && this.swiperComponent.$swiper.isBeginning);
                        this.isEnd = Boolean(this.swiperComponent && this.swiperComponent.$swiper && this.swiperComponent.$swiper.isEnd);
                        if (this.hasReachedTheLimit || this.locked)
                            return [2 /*return*/];
                        if (!this.isEnd) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.expand(args)];
                    case 1:
                        _a.sent();
                        this.isEnd = false;
                        _a.label = 2;
                    case 2:
                        this.$emit('slideChangeAfterExpand', args);
                        return [2 /*return*/];
                }
            });
        });
    };
    AdapSwiper.prototype.expand = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.locked = true;
                        if (!this.$await) return [3 /*break*/, 2];
                        // @ts-ignore
                        return [4 /*yield*/, this.$await.run(this.spinner, function () { return _this.collection.expand(); })];
                    case 1:
                        // @ts-ignore
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.collection.expand()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.locked = false;
                        this.$emit('expand', args);
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", ExpansibleCollection)
    ], AdapSwiper.prototype, "collection", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], AdapSwiper.prototype, "slideClass", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], AdapSwiper.prototype, "awaitIsHidden", void 0);
    __decorate([
        Prop({ type: String, default: 'list' }),
        __metadata("design:type", String)
    ], AdapSwiper.prototype, "spinner", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], AdapSwiper.prototype, "cleanupStylesOnDestroy", void 0);
    __decorate([
        Prop({ type: Object }),
        __metadata("design:type", Object)
    ], AdapSwiper.prototype, "options", void 0);
    __decorate([
        Watch('collection.items', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], AdapSwiper.prototype, "itemsEvent", null);
    AdapSwiper = __decorate([
        Component({ template: template })
    ], AdapSwiper);
    return AdapSwiper;
}(Mixins(MixinAdapScreenSize)));
export { AdapSwiper };
//# sourceMappingURL=AdapSwiper.js.map